import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "divider-vertical-2", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2 32", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("path", { d: "M1 11.5A.75.75 0 101 10a.75.75 0 000 1.5zM1 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 3.5A.75.75 0 101 17a.75.75 0 000 1.5zM1 22a.75.75 0 100-1.5.75.75 0 000 1.5z", fill: "currentColor", fillOpacity: 0.3 }));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
